import CurrencyCode from "@/module/main/dto/CurrencyCodeEnum";
import BaseMapper from "@/module/main/service/BaseMapper";
import IAmount from "@/module/main/dto/financing-v1/IAmount";
import Amount from "@/module/main/dto/financing-v1/Amount";

abstract class BaseMapperV1 extends BaseMapper {
    protected createAmount(price: string, currencyCode: CurrencyCode): IAmount | undefined {
        let amount: IAmount | undefined = undefined;
        const priceNumber: number | undefined = this.stringToNumber(price);

        if (priceNumber != undefined) {
            amount = new Amount(Math.round(priceNumber * 100), currencyCode);
        }

        return amount;
    }
}

export default BaseMapperV1;
